import React from 'react';

const InfoIcon = (props) => (
  <svg {...props} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9 13.4444L9 7.22222M9 4.56441V4.55553M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z'
      stroke={props.fill}
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);

export default InfoIcon;
